import { assign, camelCase, concat, join, keys, map, merge, values, zipObject, isEmpty } from 'lodash/fp'

import _ from 'lodash'
import { createSelectorCreator, defaultMemoize } from 'reselect'

export const anyValue = () => true

export const assignLeft = assign.convert({ rearg: true })
export const mergeLeft = merge.convert({ rearg: true })

export const isUUID = v => /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(v)

export const validator = (requiredKeys = {}) =>
  (object, invalidReturns = false) => {
    if (typeof object !== 'object') {
      console.error(`${object} is not an object`)
      return object
    }

    const isValid = _.reduce(requiredKeys, (acc, validator, key) => {
      if (!acc) {
        return false
      }
      if (typeof validator !== 'function') {
        console.warn(`Validator for "${key}" must be a function.`)
        return acc
      }
      const valid = validator(object[key])
      if (!valid) {
        console.warn(`Validator for "${key}" disagrees with value:`, object[key])
      }
      return valid
    }, true)

    if (invalidReturns) {
      return isValid && object
    }
    return object
  }

//  ██████╗ ███████╗██████╗ ██╗   ██╗ ██████╗███████╗██████╗ ███████╗
//  ██╔══██╗██╔════╝██╔══██╗██║   ██║██╔════╝██╔════╝██╔══██╗██╔════╝
//  ██████╔╝█████╗  ██║  ██║██║   ██║██║     █████╗  ██████╔╝███████╗
//  ██╔══██╗██╔══╝  ██║  ██║██║   ██║██║     ██╔══╝  ██╔══██╗╚════██║
//  ██║  ██║███████╗██████╔╝╚██████╔╝╚██████╗███████╗██║  ██║███████║
//  ╚═╝  ╚═╝╚══════╝╚═════╝  ╚═════╝  ╚═════╝╚══════╝╚═╝  ╚═╝╚══════╝

export const createReducer = (initialState = {}, handlers = {}) => (state = initialState, action = {}) => {
  // eslint-disable-next-line
  if (handlers.hasOwnProperty(action.type)) {
    return handlers[action.type](action.payload)(state)
  }
  return state
}

export const createTypes = (typeKeys, optionalNamespace) => {
  const typeValues = isEmpty(optionalNamespace)
    ? typeKeys
    : map(type => join('/', concat(optionalNamespace, type)), typeKeys)
  return zipObject(typeKeys, typeValues)
}

export const createActions = typeMap => {
  const types = keys(typeMap)
  const typeValues = values(typeMap)
  const actionKeys = map(camelCase, types)
  const actionFunction = type => payload => ({ type, payload })
  return zipObject(actionKeys, map(actionFunction, typeValues))
}

//  ███████╗███████╗██╗     ███████╗ ██████╗████████╗ ██████╗ ██████╗ ███████╗
//  ██╔════╝██╔════╝██║     ██╔════╝██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗██╔════╝
//  ███████╗█████╗  ██║     █████╗  ██║        ██║   ██║   ██║██████╔╝███████╗
//  ╚════██║██╔══╝  ██║     ██╔══╝  ██║        ██║   ██║   ██║██╔══██╗╚════██║
//  ███████║███████╗███████╗███████╗╚██████╗   ██║   ╚██████╔╝██║  ██║███████║
//  ╚══════╝╚══════╝╚══════╝╚══════╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝╚══════╝

export const createSelector = createSelectorCreator(
  defaultMemoize,
  _.isEqual
)
